import { Template } from './template.js'

const Auth = {
	template: Template,
	data: function() {
		return {
			username: '',
			password: ''
		}
	},

	methods: {
		setLocale(locale) {
			console.log('меняю');
			this.$emit("setLocale", locale);
		},
		login() {
			var cont = this;
			//авторизация в плагине
			this.$auth(this.username, this.password,
				function() { //авторизация успешна
					cont.$emit("login-result", true);

					let currentPage = localStorage.getItem('currentPage');
					if(!currentPage){
						currentPage = "/";
					}
					cont.$router.push(currentPage);

					console.log('authorized');
					
					//спросить пользователя после логина о приеме уведомлений
					var js = document.createElement('script');
					js.src = "./js/firebase-services.js";
					document.body.appendChild(js);
				},
				function() { // авторизация провалилась
					cont.$emit("login-result", false);
					console.log('authorization failed');
					cont.password = '';
				});
		}
	}
}

export { Auth }


// WEBPACK FOOTER //
// ./src/app/js/components/auth/component.js